import React from "react";
import InputText from "../../../../atoms/InputText/InputText";

export default function Id() {

    return (
        <div className="inputText-general">
            <InputText
                id={"centerId"}
                label={"Zentrums-ID"}
                type={"text"}
                variant={"outlined"}
                placeholder={'test'}
            />
        </div>
    );
}

